// Internal method for camel case
const getCamelCase = (appName, utm = false) => {
  // Clean up all special characters
  const cleanUpName = appName.replace(/[^a-zA-Z0-9]/g, '-')
  // Splitting using '-'
  if (cleanUpName.includes('-')) {
    const temp = appName.split('-')
    for (let i = 0; i < temp.length; i++) {
      if (utm) {
        temp[i] = temp[i][0].toLowerCase() + temp[i].substr(1)
      } else {
        temp[i] = temp[i][0].toUpperCase() + temp[i].substr(1)
      }
    }
    return temp.join('')
  }
  return cleanUpName
}

// Get Env name
export function getEnvName () {
  switch (process.env.APP_NAME) {
    case 'Societyforsciencebcm':
      return 'SocietyForScienceBcm'
    default:
      return getCamelCase(process.env.APP_NAME)
  }
}
// Get UTM name
export function getUTMName () {
  return getCamelCase(process.env.APP_NAME, true)
}
// Export get ENV
export default {
  getEnvName,
  getUTMName
}
